import React from 'react';

export const sort = (color = 'rgba(125,125,125, 0.5)', filled = true, width = 20, height = 25) => (
  <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 511.627 511.627'>
    <g>
      <g>
        <path
          d='M333.584,438.536h-73.087c-2.666,0-4.853,0.855-6.567,2.573c-1.709,1.711-2.568,
          3.901-2.568,6.564v54.815
		    	c0,2.673,0.855,4.853,2.568,6.571c1.715,1.711,3.901,2.566,6.567,2.566h73.087c2.666,
          0,4.856-0.855,6.563-2.566
		    	c1.718-1.719,2.563-3.898,2.563-6.571v-54.815c0-2.663-0.846-4.854-2.563-6.564C338.44,
          439.392,336.25,438.536,333.584,438.536z'
          fill={filled ? color : 'none'}
        />
        <path
          d='M196.54,401.991h-54.817V9.136c0-2.663-0.854-4.856-2.568-6.567C137.441,0.859,135.254,
          0,132.587,0H77.769
			    c-2.663,0-4.856,0.855-6.567,2.568c-1.709,1.715-2.568,3.905-2.568,6.567v392.855H13.816c-4.184,0-7.04,
          1.902-8.564,5.708
			    c-1.525,3.621-0.855,6.95,1.997,9.996l91.361,91.365c2.094,1.707,4.281,2.562,6.567,2.562c2.474,0,
          4.665-0.855,6.567-2.562
			    l91.076-91.078c1.906-2.279,2.856-4.571,2.856-6.844c0-2.676-0.859-4.859-2.568-6.584
		    	C201.395,402.847,199.208,401.991,196.54,401.991z'
          fill={filled ? color : 'none'}
        />
        <path
          d='M388.4,292.362H260.494c-2.666,0-4.853,0.855-6.567,2.566c-1.71,1.711-2.568,
          3.901-2.568,6.563v54.823
		    	c0,2.662,0.855,4.853,2.568,6.563c1.714,1.711,3.901,2.566,6.567,2.566H388.4c2.666,
          0,4.855-0.855,6.563-2.566
		    	c1.715-1.711,2.573-3.901,2.573-6.563v-54.823c0-2.662-0.858-4.853-2.573-6.563C393.256,
          293.218,391.066,292.362,388.4,292.362z'
          fill={filled ? color : 'none'}
        />
        <path
          d='M504.604,2.568C502.889,0.859,500.702,0,498.036,0H260.497c-2.666,0-4.853,
          0.855-6.567,2.568
		    	c-1.709,1.715-2.568,3.905-2.568,6.567v54.818c0,2.666,0.855,4.853,2.568,
          6.567c1.715,1.709,3.901,2.568,6.567,2.568h237.539
		    	c2.666,0,4.853-0.855,6.567-2.568c1.711-1.714,2.566-3.901,2.566-6.567V9.136C507.173,
          6.473,506.314,4.279,504.604,2.568z'
          fill={filled ? color : 'none'}
        />
        <path
          d='M443.22,146.181H260.494c-2.666,0-4.853,0.855-6.567,2.57c-1.71,1.713-2.568,
          3.9-2.568,6.567v54.816
			    c0,2.667,0.855,4.854,2.568,6.567c1.714,1.711,3.901,2.57,6.567,
          2.57H443.22c2.663,0,4.853-0.855,6.57-2.57
		    	c1.708-1.713,2.563-3.9,2.563-6.567v-54.816c0-2.667-0.855-4.858-2.563-6.567C448.069,
          147.04,445.879,146.181,443.22,146.181z'
          fill={filled ? color : 'none'}
        />
      </g>
    </g>
  </svg>
);
// {
/* <path
      d='M33.5,19.14V12a1.5,1.5,0,0,0-3,0v7.14a6.07,6.07,0,0,0,0,11.
      74V52a1.5,1.5,0,0,0,3,0V30.88C39.52,29.34,39.52,20.67,33.5,19.14Z'
      fill={filled ? color : 'none'}
    />
    <path
      d='M48.94,26.13V12a1.5,1.5,0,0,0-3,0V26.13a6.07,6.07,0,0,0,0,11.
      74V52a1.5,1.5,0,0,0,3,0V37.87C55,36.33,55,27.66,48.94,26.13Z'
      fill={filled ? color : 'none'}
    />
    <path
      d='M18.06,37V12a1.5,1.5,0,1,0-3,0V37a6.07,6.07,0,0,0,0,11.
      73V52a1.5,1.5,0,0,0,3,0V48.74A6.07,6.07,0,0,0,18.06,37Z'
      fill={filled ? color : 'none'}
    /> */
// }
